import { useEffect, useRef, useState } from "react";
import { CustomComponentProps } from "utils/types/generalTypes";

export type CountDownProps = CustomComponentProps & {
    seconds: number;
    handleEnd: Function;
    formatTimer?: boolean;
};
const CountDown = ({
    seconds,
    handleEnd,
    // formatTimer = false,
    className,
    style
}: CountDownProps) => {
    // const [t] = useTranslation("global");
    const [countDown, setCountDown] = useState(seconds);
    const timerId = useRef();

    useEffect(() => {
        // @ts-ignore
        timerId.current = setInterval(() => {
            setCountDown((prev) => prev - 1);
        }, 1000);
        return () => clearInterval(timerId.current);
    }, []);

    useEffect(() => {
        if (countDown <= 0) {
            clearInterval(timerId.current);
            handleEnd(false);
        }
    }, [countDown]);
    // {` ${className} ${countDown <= 0 ? "is-hidden" : ""}`}
    return (
        <span className={className} style={style}>
            Resend OTP in {Math.floor(countDown / 60)}:{countDown % 60}
        </span>
    );
};

export default CountDown;
